// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-overlay-dialog .el-dialog{width:30%}@media(max-width:1500px){.el-overlay-dialog .el-dialog{width:50%}.el-overlay-dialog .el-dialog .el-dialog__body{padding:0 20px}}@media(max-width:1100px){.el-overlay-dialog .el-dialog{width:70%}}@media(max-width:870px){.el-overlay-dialog .el-dialog{width:90%}}@media(max-width:580px){.el-overlay-dialog .el-dialog{width:100%;height:100%;margin:0;overflow-x:scroll}}", ""]);
// Exports
module.exports = exports;
